import React from 'react';
import { Row, Col, Card, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Icon from '../../../../components/icon/Icon';

const CarSelector = ({ cars, selectedCars = [], onToggleCar, isEditing }) => {
  // --- Empty State ---
  if (!cars || cars.length === 0) {
    return (
      <div className="border border-light border-dashed rounded-3 bg-light-subtle p-5 text-center">
        <div className="text-muted mb-3">
          <Icon icon="DirectionsCar" size="2x" className="opacity-25" />
        </div>
        <div className="small text-muted">
          {isEditing ? 'Aucun véhicule disponible.' : 'Aucun véhicule assigné.'}
        </div>
      </div>
    );
  }

  const currentCarIds = selectedCars.map(car => (typeof car === 'object' ? car._id : car));

  return (
    <div>
      <style>{`
        .car-card {
          transition: all 0.2s ease;
        }
        .car-card:hover {
          border-color: #dee2e6 !important;
          box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }
        .extra-small { font-size: 0.75rem; }
        .border-dashed { border-style: dashed !important; }
        .cursor-help { cursor: help; }
      `}</style>

      <Row className="">
        {cars.map(car => {
          const isSelected = currentCarIds.includes(car._id);
          const drivers = car.conducteurs || [];
          const primaryDriver = drivers[0];
          const hasExtraDrivers = drivers.length > 1;

          // Tooltip pour les conducteurs multiples
          const renderDriverTooltip = (props) => (
            <Tooltip id={`driver-tooltip-${car._id}`} {...props}>
              <div className="text-start p-1">
                <strong className="d-block mb-1 border-bottom pb-1 extra-small">Autres conducteurs:</strong>
                {drivers.slice(1).map((d, idx) => (
                  <div key={idx} className="small text-nowrap">
                    • {d.technicien?.name || 'Inconnu'}
                  </div>
                ))}
              </div>
            </Tooltip>
          );

          return (
            <Col xs={12} sm={6} key={car._id}>
              <Card
                className={`
                  car-card border border-light shadow-sm bg-white  overflow-hidden
                  ${isSelected ? 'border-primary bg-l25-primary bg-opacity-5' : ''}
                `}
                onClick={() => isEditing && onToggleCar(car._id)}
                style={{ cursor: isEditing ? 'pointer' : 'default' }}
              >
                <Card.Body className="p-3 d-flex flex-column">

                  {/* LINE 1: Header - Icon + Name + Plate */}
                  <div className="d-flex justify-content-between align-items-start ">
                    <div className="d-flex align-items-center overflow-hidden flex-grow-1">
                      <div className={`
                        rounded-circle me-3 flex-shrink-0 d-flex align-items-center justify-content-center
                        ${isSelected ? 'bg-primary text-white' : 'bg-light text-muted'}
                      `} style={{ width: 36, height: 36 }}>
                        <Icon icon="DirectionsCar" size="sm" />
                      </div>
                      <div className="text-truncate flex-grow-1">
                        <div className="fw-bold text-dark text-truncate small">
                          {car?.conducteurs?.map(c => c?.technicien?.name)?.join(", ")}
                        </div>
                        <div className="extra-small text-muted">
                          <span className=" text-muted fw-medium">
                            {car.companyId?.name}
                          </span>
                        </div>
                      </div>
                    </div>

                    {isSelected && (
                      <div className="text-primary flex-shrink-0">
                        <Icon icon="CheckCircle" size="lg" />
                      </div>
                    )}
                  </div>

                  {/* LINE 3: Footer - Driver + Status */}
                  {/* <div className="">
                    <div className="d-flex justify-content-between align-items-center">



                      <div className="d-flex align-items-center">
                        <span
                          className={`me-1 rounded-circle bg-${getStatusColor(car.statut)}`}
                          style={{ width: 8, height: 8 }}
                        ></span>
                        <span className="extra-small fw-medium text-dark">
                          {getStatusLabel(car.statut)}
                        </span>
                      </div>
                    </div>
                  </div> */}
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

// --- Helpers ---
const getStatusColor = (status) => {
  const map = {
    disponible: 'success',
    louee: 'info',
    panne: 'danger',
    entretien: 'warning',
    reserve: 'primary',
    en_cours: 'warning',
    termine: 'success'
  };
  return map[status] || 'secondary';
};

const getStatusLabel = (status) => {
  const map = {
    disponible: 'Disponible',
    louee: 'Louée',
    panne: 'Panne',
    entretien: 'Entretien',
    reserve: 'Réservée',
    en_cours: 'En cours',
    termine: 'Terminée'
  };
  return map[status] || status;
};

export default CarSelector;